import { createSlice } from '@reduxjs/toolkit';

const initialBoxesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  boxForView: undefined,
  error: null,
  msg: null,
  pageNumber: 1,
};
export const callTypes = {
  list: 'list',
  action: 'action',
};

export const boxesSlice = createSlice({
  name: 'boxes',
  initialState: initialBoxesState,
  reducers: {
    catchError: (state, action) => {
      //state.error = `${action.type}: ${action.payload.error}`;
      state.error = `${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    sendMsg: (state, action) => {
      state.msg = `${action.payload.msg}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.msg = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findBoxes
    boxesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.msg = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.pageNumber = 1;
      return state;
    },
    // getBoxesById
    boxFetched: (state, action) => {
      state.actionsLoading = false;
      state.boxForView = action.payload.boxForView;
      state.error = null;
      state.msg = null;
      return state;
    },

    // update Boxes
    boxUpdated: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.boxForView = action.payload.boxForView;
      return state;
    },
  },
});
